import { apiClientGeral } from '@/plugins/axios'

export default {
  getTroncos() {
    return apiClientGeral().get('/troncos')
  },
  getTronco(id) {
    return apiClientGeral().get(`/troncos/${id}`)
  },
  getUseTronco(id) {
    return apiClientGeral().get(`/troncos/use/${id}`)
  },
  postTronco(tronco) {
    return apiClientGeral().post('/troncos', tronco)
  },
  putTronco(tronco) {
    return apiClientGeral().put(`/troncos/${tronco._id}`, tronco)
  },
  deleteTronco(id) {
    return apiClientGeral().delete(`/troncos/${id}`)
  },

  getrotas() {
    return apiClientGeral().get('/rotas')
  },
  getGruposDeRotas() {
    return apiClientGeral().get('/grupo-rotas')
  }
}
